import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

export interface CustomerKPIs {
  filters: {
    type: string;
  };
  selectedType: string;
  actions: {
    canWarn: boolean;
    canTempSuspend: boolean;
    canPermSuspend: boolean;
  };
}

const initialState: CustomerKPIs = {
  filters: {
    type: '',
  },
  selectedType: null,
  actions: {
    canWarn: false,
    canTempSuspend: false,
    canPermSuspend: false,
  },
};

export const customerKPIsSlice = createSlice({
  name: 'CustomerKPIs',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setSelectedType: (state, action) => {
      state.selectedType = action.payload;
    },
    setActions: (state, action) => {
      state.actions = {
        ...state.actions,
        ...action.payload,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setFilters, setSelectedType, setActions } =
  customerKPIsSlice.actions;
export const useCustomerKpis = () =>
  useSelector((state: RootState) => state?.CustomerKPIs);

export default customerKPIsSlice.reducer;
